<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block  d-flex justify-content-center loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div   v-if="is_load">
        <common-user-page :user="user" />
        <div class="col-12 mt-3 text-center">
          <p><router-link class="btn"     tag="a"
              :to="{name: 'user_page_addreview', params: { user_id: user.last_id }}" >Добавить отзыв</router-link></p>

        </div>
        <div class="col-12 mt-2 text-center" v-if="reviews.length==0">
          <p>отзывы не найдены!</p>
        </div>
        <div class="container mt-3">
          <div class="col-12 mt-2" v-if="reviews.length>0">
            <div class="row m-3 second_section   developer_block_review section_gray_bg"  v-for="(review,review_index) in reviews">
              <div class="col-4 col-md-2 block_avatar">

                <router-link v-if="review.who.avatar"   tag="a"
                    :to="{name: 'user_page_main', params: { user_id: review.who.last_id }}" ><v-lazy-image :src="image_url+review.who.avatar" class="mt-2 img img-thumbnail" v-if="review.who.avatar" /></router-link>

                <div class="avatar" v-if="review.who.avatar==null">

                  <avatar v-if="review.who.avatar==null" :size="35" :username="review.who.name"
                      class="rounded-circle"></avatar>

                </div>
              </div>
              <div class="col-8  review_data">
                <router-link v-if="review.who.avatar"   tag="a"
                    :to="{name: 'user_page_main', params: { user_id: review.who.last_id }}" > <h3 class="client_name">{{ review.who.name }}</h3></router-link>
                <p><span class="badge badge-circle badge-info">{{ review.rating}}</span></p>
                <p v-if="review.items && review.items.length>0">
                  за товары: <router-link v-for="(item,item_index) in review.items"  tag="a"
                    :to="{name: 'shop_item_id', params: {id:item.last_id  }}">{{ item.title}}</router-link>
                </p>
                <p v-if="review.service && review.service.name">за услугу: <router-link  tag="a"
                    :to="{name: 'service_page', params: {service_id:review.service.last_id  }}">{{ review.service.name}}</router-link></p>
                <editorjsrender   :blocks_json="review.review.blocks"></editorjsrender>
                <p>{{ review.created_at }}  <router-link tag="a" :to="{name:'user_page_one_review',params:{user_id:user.last_id,id:review.last_id}}"><i class="fa fa-comments"></i> {{ review.comments_count }}</router-link></p>
              </div>





            </div>

          </div>
        </div>








      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";
import VLazyImage from "v-lazy-image/v2";
import Editorjsrender from "@/models/Editorjsrender";

export default {
  name: "UserPageReviews",
  data(){
    return {
      "is_load":false,
      'user':null,
      'reviews':[],
      'image_url':null,
    };
  },
  components: {LoadingBlock,CommonUserPage,VLazyImage,'editorjsrender': Editorjsrender,},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id);
  },
  methods:{
    loadMainData(id){
      var app=this;
      Api.loadUserPageReviews(id,function(data){
        app.user=data.user;
        app.reviews=data.reviews;
        app.is_load=true;
      },function(error){

        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });
    }
  }
}
</script>

<style scoped>

</style>